export * from './ftsInfo.component';
export * from './ftsSubject.component';
